import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class OrderAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/order');
  }

  async resolveCodOnhold(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/resolveCodOnhold';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async cancel(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/cancel';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async resolveExchangeOnhold(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/resolveExchangeOnhold';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async resolveFrequentReturnerOnhold(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/resolveFrequentReturnerOnhold';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async sendPaymentReminder(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/send-cod-onhold-payment-reminder';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async getDelayedExpressShippingRefundQuote(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/delayed-express-shipping-refund/quote';
      const response = await axiosInstance.get(`${url}`);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async createDelayedExpressShippingRefund(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/delayed-express-shipping-refund';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async getFrequentReturnRefundRelaxationQuote(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/frequent-return-refund-relaxation/quote';
      const response = await axiosInstance.get(`${url}`);
      if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
        throw new Error(response.data?.status?.message || 'Unable to fetch frequent-return refund quote.');
      }
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async relaxFrequentReturnRefundRestriction(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/frequent-return-refund-relaxation';
      const response = await axiosInstance.put(`${url}`, payload);
      if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
        throw new Error(response.data?.status?.message || 'Unable to relax frequent-return refund restriction.');
      }
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async updateDeliveryModeAndAddress(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/address/delivery-mode-and-address-update';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async updateBillingAndGstin(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.orderId + '/address/gstin-billing-update';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }
}

export default OrderAPIClient;
